import React, { useState, useContext } from 'react';
import {
  SafeAreaView,
  StyleSheet,
  View,
  Text,
  TextInput,
  Button,
  Image,
  Alert,
  TouchableOpacity,
  Modal,
  ScrollView,
  ActivityIndicator,
} from 'react-native';
import { EstoqueContext } from '../Contexts/ContextEstoque';
import firebase from 'firebase';


var app = firebase.app();
var db = app.database();
var valor

const TelaVerifica = (props) => {
  const { state, actions } = useContext(EstoqueContext);
  console.log(state, actions)
    db.ref('estoque').once('value').then((snapshot) =>{
      console.log("a")
      valor = snapshot.val();
      var zap = "teste"
      console.log(valor)
      console.log("state.itens antes", state.itens)
      console.log("state antes",state)
      state.itens = valor
      actions.setEstoque({teste: zap});
      console.log("state.itens depois", state.itens)
      console.log("state depois", state)
      console.log(`valor: ${valor}`)
      if(valor != undefined){
        props.navigation.navigate('LOGIN')        
      }
    })
    return(
        <View style={design.View}>
            <View style={design.centeredView}>
            <ActivityIndicator size="large" color="rgba(0, 58, 109, 255)" />
                {/* <Text style={design.textStyle}>Carregando...</Text>
                <Text style={design.avisoStyle}>Caso o carregamento demore muito, verifique sua conexão com a internet e reinicie o app.</Text> */}
            </View>
        </View>
      );
}
const design = StyleSheet.create({
    centeredView: {
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: '60%',
      margin: 17,
      height: 150,
      borderRadius: 20,
    },
  
    textStyle: {
      color: 'white',
      fontWeight: 'bold',
      textAlign: 'center',
      fontSize: 25,
      marginTop: 0,
      color: 'rgba(255, 255, 255, 255)',
    },

    avisoStyle: {
        color: 'white',
        fontWeight: '900',
        textAlign: 'center',
        fontSize: 15,
        marginTop: 20,
        color: 'rgba(255, 255, 255, 255)',

      },
      View: {
        height: "100%",
        width: '100%',
        backgroundColor: 'rgba(179, 179, 179, 255)',
      },

  });

export default TelaVerifica;